import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { observer } from 'mobx-react-lite';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { Button, TextField, LinearProgress, Chip } from '@mui/material';
import { Icon, toast, InputWithIcon, ExpandedTooltip } from '@livable/saas-react-components';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import { useDelay } from 'src/utils/hooks';
import { FilterMenu } from './FilterMenu';
import { CompanyActionsMenu } from './CompanyActionsMenu';
import moment from 'moment';
import useStyles from './../styles';
import { dateToFormat } from 'src/utils/date';
import { useNavigate } from 'react-router-dom';
export const CompaniesSelector = observer(_ref => {
  var _store$homeDashboardS6, _store$homeDashboardS7, _store$homeDashboardS8, _store$homeDashboardS9, _store$homeDashboardS0, _store$homeDashboardS1, _store$homeDashboardS10, _getCompaniesResultLi;
  let handleOpenCreateAccountModal = _ref.handleOpenCreateAccountModal;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const store = useStore();
  const navigate = useNavigate();
  const _useReducer = useReducer(x => x + 1, 0),
    _useReducer2 = _slicedToArray(_useReducer, 2),
    forceUpdate = _useReducer2[1];
  const _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchKey = _useState2[0],
    setSearchKey = _useState2[1];
  const _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    tagsFilter = _useState4[0],
    setTagsFilter = _useState4[1];
  const _useState5 = useState('unsort'),
    _useState6 = _slicedToArray(_useState5, 2),
    sortModel = _useState6[0],
    setSortModel = _useState6[1];
  const _useState7 = useState('N/A'),
    _useState8 = _slicedToArray(_useState7, 2),
    totalCount = _useState8[0],
    setTotalCount = _useState8[1];
  const _useState9 = useState('N/A'),
    _useState0 = _slicedToArray(_useState9, 2),
    currentCount = _useState0[0],
    setCurrentCount = _useState0[1];
  const _useState1 = useState(0),
    _useState10 = _slicedToArray(_useState1, 2),
    paginationPage = _useState10[0],
    setPaginationPage = _useState10[1];
  // const [paginationPageSize, setPaginationPageSize] = useState(100);
  const paginationPageSize = 100;
  const fetchUserProfile = async () => {
    await store.account.getProfileAsync.run(false);
  };
  const scrollToTargetRef = useRef();
  const scrollToSelectedCompany = () => {
    if (scrollToTargetRef.current) {
      scrollToTargetRef.current.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  const handleCompanySelect = async function (company) {
    let fetchCompany = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    navigate("/active_dashboard");
    await store.admin.getAdminAccountLoginImpersonateAsync.run({
      companyId: company.companyId
    }, [company.companyId]);
    let companyAccessData;
    if (!company.companyHasAccessToken || moment(company.companyAccessData.expiresOn).utc().valueOf() < moment.utc().valueOf()) {
      const refreshAccessTokenAsyncRsp = await store.account.refreshAccessTokenAsync.run(null, [company.companyId]);
      if (refreshAccessTokenAsyncRsp !== null && refreshAccessTokenAsyncRsp !== void 0 && refreshAccessTokenAsyncRsp.isSuccessful) {
        companyAccessData = refreshAccessTokenAsyncRsp.response;
      }
    } else {
      await store.account.refreshAccessTokenAsync.run(company.companyAccessData);
      companyAccessData = company.companyAccessData;
    }
    await store.homeDashboardStore.setCompanyAccessId(company.companyId, companyAccessData);
    store.admin.saveSelectedCompanyName(company.companyName);
    if (fetchCompany) {
      // NOTE: TBD
      // await store.company.getCompaniesAsync.run();
    }
    toast('success', {
      body: ["Company switched to ".concat(company.companyName, "!")]
    });
    scrollToSelectedCompany();
  };
  const fetchCompaniesList = async _ref2 => {
    let _ref2$paginationPageE = _ref2.paginationPageExt,
      paginationPageExt = _ref2$paginationPageE === void 0 ? paginationPage || 0 : _ref2$paginationPageE,
      _ref2$paginationPageS = _ref2.paginationPageSizeExt,
      paginationPageSizeExt = _ref2$paginationPageS === void 0 ? paginationPageSize || 100 : _ref2$paginationPageS,
      _ref2$scrollToSelecte = _ref2.scrollToSelectedCompanyEnabled,
      scrollToSelectedCompanyEnabled = _ref2$scrollToSelecte === void 0 ? true : _ref2$scrollToSelecte;
    if (store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) {
      store.admin.getCompaniesListAsync.run({
        page: paginationPageExt || paginationPage + 1,
        pageSize: paginationPageSizeExt || paginationPageSize,
        search: searchKey,
        tagIds: tagsFilter.join('&')
      }).then(companyListResp => {
        setTotalCount(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.totalCount);
        setCurrentCount(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.items.length);
        store.homeDashboardStore.parseCompanyAdminList(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.items);
        store.homeDashboardStore.setCompanyAdminListTotal(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.totalCount);
        if (scrollToSelectedCompanyEnabled) scrollToSelectedCompany();
      });
    }
  };
  useDelay(() => {
    fetchCompaniesList({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchKey, paginationPage, paginationPageSize], 300);
  useEffect(() => {
    fetchUserProfile().then(async () => {
      var _store$homeDashboardS, _store$homeDashboardS2;
      if ((store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && ((_store$homeDashboardS = store.homeDashboardStore.getCompanySelectorList) === null || _store$homeDashboardS === void 0 ? void 0 : _store$homeDashboardS.length) === 0) {
        await store.tags.getAllTagsAsync.run();
        const companyListResp = await store.admin.getCompaniesListAsync.run({
          page: paginationPage + 1,
          pageSize: paginationPageSize,
          search: searchKey
        });
        store.homeDashboardStore.parseCompanyAdminList(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.items);
        store.homeDashboardStore.setCompanyAdminListTotal(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.totalCount);
        setTotalCount(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.totalCount);
        setCurrentCount(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.items.length);
      } else if ((store.account.userProfile.isUserAdmin || store.account.userProfile.isUserSuperAdmin) && ((_store$homeDashboardS2 = store.homeDashboardStore.getCompanySelectorList) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.length) !== 0) {
        var _store$homeDashboardS3;
        setTotalCount(store.homeDashboardStore.getCompanyAdminListTotal);
        setCurrentCount((_store$homeDashboardS3 = store.homeDashboardStore.getCompanySelectorList) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.length);
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const getCompaniesResultList = () => {
    return store.homeDashboardStore.getCompanySelectorList
    // .filter(company => company.companyName !== store.admin.companyName)
    .filter(i => {
      return tagsFilter.length ? tagsFilter.every(r => i.tagIds.includes(r)) : true;
    }).filter(i => {
      const searchPhrase = searchKey.toLocaleLowerCase().trim();
      return searchKey.length > 0 ? (i.companyName ? i.companyName.toLocaleLowerCase().includes(searchPhrase) > 0 : false) || (i.email ? i.email.toLocaleLowerCase().includes(searchPhrase) > 0 : false) : true;
    }).sort((a, b) => {
      var _ref3, _ref4;
      if (sortModel === 'asc') return (_ref3 = '' + (a === null || a === void 0 ? void 0 : a.companyName)) === null || _ref3 === void 0 ? void 0 : _ref3.localeCompare(b === null || b === void 0 ? void 0 : b.companyName, undefined, {
        numeric: true
      });
      if (sortModel === 'desc') return (_ref4 = '' + (b === null || b === void 0 ? void 0 : b.companyName)) === null || _ref4 === void 0 ? void 0 : _ref4.localeCompare(a === null || a === void 0 ? void 0 : a.companyName, undefined, {
        numeric: true
      });
    });
  };
  const tagUpdateTrigger = async () => {
    await store.tags.getAllTagsAsync.run();
    const companyListResp = await store.admin.getCompaniesListAsync.run({
      page: paginationPage + 1,
      pageSize: paginationPageSize,
      search: searchKey
    });
    store.homeDashboardStore.parseCompanyAdminList(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.items);
    store.homeDashboardStore.setCompanyAdminListTotal(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.totalCount);
    setTotalCount(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.totalCount);
    setCurrentCount(companyListResp === null || companyListResp === void 0 ? void 0 : companyListResp.items.length);
  };

  // const getLettersIcon = str => {
  //   const arr = str.split(' ');
  //   if (arr.length === 1) {
  //     return arr[0][0].toLocaleUpperCase();
  //   } else {
  //     return `${arr[0][0]}${arr[1][0]}`.toLocaleUpperCase();
  //   }
  // };

  const listInnerRef = useRef();
  const onScroll = () => {
    if (listInnerRef.current) {
      const _listInnerRef$current = listInnerRef.current,
        scrollTop = _listInnerRef$current.scrollTop,
        scrollHeight = _listInnerRef$current.scrollHeight,
        clientHeight = _listInnerRef$current.clientHeight;
      // NOTE: 3 is a magic number to make sure height is at the bottom because of the absolute positioning of the loading bar
      const isNearBottom = scrollTop + clientHeight + 3 >= scrollHeight;
      if (isNearBottom) {
        var _store$homeDashboardS4, _store$homeDashboardS5;
        fetchCompaniesList({
          paginationPageSizeExt: !!((_store$homeDashboardS4 = store.homeDashboardStore.getCompanySelectorList) !== null && _store$homeDashboardS4 !== void 0 && _store$homeDashboardS4.length) ? ((_store$homeDashboardS5 = store.homeDashboardStore.getCompanySelectorList) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.length) + 100 : 100,
          scrollToSelectedCompanyEnabled: false
        });
        /* TODO: Not working because component recreates and paginationPage is resets
            so it should not use component state, need to use store state for pagination for this to work
        */
        // setPaginationPage(paginationPage + 1);
      }
    }
  };
  const updateList = async () => {
    forceUpdate();
    await fetchCompaniesList({});
  };
  const isImpersonateInProgress = store.admin.getAdminAccountLoginImpersonateAsync.inProgress || store.account.refreshAccessTokenAsync.inProgress;

  // NOTE: register scroll to bottom for lazy loading extra companies
  useEffect(() => {
    const listInnerElement = listInnerRef.current;
    if (listInnerElement) {
      listInnerElement.addEventListener('scroll', onScroll);

      // Clean-up
      return () => {
        listInnerElement.removeEventListener('scroll', onScroll);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    scrollToSelectedCompany();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [store.homeDashboardStore.companiesNavOpen]);
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smartNav, " ").concat(!store.homeDashboardStore.companiesNavOpen ? 'close' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.smartNavContent
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.smartNavControll, " ").concat(!store.homeDashboardStore.companiesNavOpen ? 'close' : ''),
    onClick: () => {
      store.homeDashboardStore.changeCompaniesNavOpenState();
      scrollToSelectedCompany();
    }
  }, /*#__PURE__*/React.createElement("span", null, "Company (", currentCount, "/", totalCount, ")"), /*#__PURE__*/React.createElement(ExpandedTooltip, {
    key: 'company_selector_expand-collapse_btn' + ((_store$homeDashboardS6 = store.homeDashboardStore) === null || _store$homeDashboardS6 === void 0 ? void 0 : _store$homeDashboardS6.enableShortcutsHintState),
    title: t("general.".concat(store.homeDashboardStore.companiesNavOpen ? 'collapse' : 'expand')) + " Alt+[ or Option+[",
    placement: 'top',
    type: "default",
    open: ((_store$homeDashboardS7 = store.homeDashboardStore) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-line-left"
  })))), /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelect
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectContent
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectContentFilters
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectContentFilterSearch
  }, /*#__PURE__*/React.createElement(InputWithIcon, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "search"
    })
  }, /*#__PURE__*/React.createElement(TextField, {
    fullWidth: true,
    size: "small",
    value: searchKey,
    variant: "outlined",
    onChange: e => {
      setSearchKey(e.target.value);
      setPaginationPage(0);
    },
    placeholder: t('general.search')
  }))), /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectContentFilterList
  }, (tagsFilter.length > 0 || sortModel !== 'unsort' || (searchKey === null || searchKey === void 0 ? void 0 : searchKey.length) > 0) && /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    key: 'company_selector_filter_reset_btn' + ((_store$homeDashboardS8 = store.homeDashboardStore) === null || _store$homeDashboardS8 === void 0 ? void 0 : _store$homeDashboardS8.enableShortcutsHintState),
    title: t('general.reset_filter'),
    placement: 'top',
    type: "warning",
    open: store.homeDashboardStore.companiesNavOpen && ((_store$homeDashboardS9 = store.homeDashboardStore) === null || _store$homeDashboardS9 === void 0 ? void 0 : _store$homeDashboardS9.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => {
      setSearchKey('');
      setTagsFilter([]);
      setSortModel('unsort');
      updateList();
    },
    'custom-attribute': '646-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "error"
  })))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FilterMenu, {
    isNavOpen: store.homeDashboardStore.companiesNavOpen,
    sortModel: sortModel,
    tagsFilter: tagsFilter,
    setTagsFilter: setTagsFilter,
    handleChange: setSortModel,
    updateList: updateList,
    menuTriggerExternal: /*#__PURE__*/React.createElement(Icon, {
      className: classes.smartNavSettingFilterIcon,
      type: "filter-new"
    })
  })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: t('Create new account'),
    key: 'company_selector_create_new_account_btn' + ((_store$homeDashboardS0 = store.homeDashboardStore) === null || _store$homeDashboardS0 === void 0 ? void 0 : _store$homeDashboardS0.enableShortcutsHintState),
    placement: (_store$homeDashboardS1 = store.homeDashboardStore) !== null && _store$homeDashboardS1 !== void 0 && _store$homeDashboardS1.enableShortcutsHintState ? 'right' : 'top',
    type: "info",
    open: store.homeDashboardStore.companiesNavOpen && ((_store$homeDashboardS10 = store.homeDashboardStore) === null || _store$homeDashboardS10 === void 0 ? void 0 : _store$homeDashboardS10.enableShortcutsHintState) || undefined
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "actionIcon",
    size: "small",
    onClick: () => {
      handleOpenCreateAccountModal();
    },
    'custom-attribute': '647-new-billing-module'
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "plus"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.adminSelectContentList, " ").concat(store.payment.failedPaymentMethods && store.payment.warningPaymentMethods && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarningBoth' : (store.payment.failedPaymentMethods || store.payment.warningPaymentMethods) && history.pathname !== '/admin' && history.pathname !== '/appfolio' && history.pathname !== '/information_banners' ? 'paymentMarginWarning' : ''),
    ref: listInnerRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.adminSelectItem, " loader-item ").concat(store.admin.getCompaniesListAsync.inProgress ? '' : 'hidden'),
    key: "Company-List-Item-Loading-Results",
    id: "Company-List-Item-ID-Loading-Results"
  }, /*#__PURE__*/React.createElement(LinearProgress, null)), !!((_getCompaniesResultLi = getCompaniesResultList()) !== null && _getCompaniesResultLi !== void 0 && _getCompaniesResultLi.length) ? getCompaniesResultList().map(company => /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.adminSelectItem, " ").concat(store.homeDashboardStore.companyAccessId === company.companyId ? 'active' : ''),
    ref: store.homeDashboardStore.companyAccessId === company.companyId ? scrollToTargetRef : null,
    key: "Company-List-Item-".concat(company.companyId),
    id: "Company-List-Item-ID-".concat(company.companyId),
    onClick: event => {
      if (store.homeDashboardStore.companyAccessId === company.companyId || event.target.getAttribute('data-menu') || event.target.parentNode.getAttribute('data-menu') || event.target.parentNode.parentNode.getAttribute('data-menu') || event.target.parentNode.getAttribute('type') === 'action-menu') return;
      if (isImpersonateInProgress) {
        return;
      }
      event.preventDefault();
      event.stopPropagation();
      handleCompanySelect(company, true);
    },
    'custom-attribute': '648-new-billing-module'
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectItemData
  }, /*#__PURE__*/React.createElement(ExpandedTooltip, {
    title: /*#__PURE__*/React.createElement("div", {
      className: classes.adminSelectItemTooltip
    }, /*#__PURE__*/React.createElement("div", null, "Code: ", company.code), /*#__PURE__*/React.createElement("div", null, "Phone: ", company.phone ? company.phone : 'N/A'), /*#__PURE__*/React.createElement("div", null, "Email: ", company.email ? company.email : 'N/A'), /*#__PURE__*/React.createElement("div", null, "Date created: ", company.createdOn ? dateToFormat(company.createdOn) : 'N/A')),
    placement: "top",
    type: "default"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectItemProperties
  }, /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "building"
    }),
    label: String(company.activeProperties).padStart(3, ' '),
    variant: "success"
  }), /*#__PURE__*/React.createElement(Chip, {
    icon: /*#__PURE__*/React.createElement(Icon, {
      type: "edit"
    }),
    label: String(company.inactiveProperties).padStart(3, ' '),
    variant: "info"
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectItemsDetails
  }, /*#__PURE__*/React.createElement("span", null, company.companyName), company.tagIds.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectItemsTags
  }, company.tagIds.map(i => {
    const tag = store.tags.getTagById(i);
    if (tag) {
      return /*#__PURE__*/React.createElement("i", {
        key: tag.id + tag.name,
        style: {
          backgroundColor: tag.color
        }
      }, tag.name);
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: classes.adminSelectItemActions,
    "data-menu": true
  }, /*#__PURE__*/React.createElement(CompanyActionsMenu, {
    tags: company.tagIds,
    companyId: company.companyId,
    trigger: tagUpdateTrigger,
    isImpersonateInProgress: isImpersonateInProgress,
    impersonateCallBackExt: innerCallback => {
      if (store.homeDashboardStore.companyAccessId !== company.companyId) {
        handleCompanySelect(company, true).then(() => {
          innerCallback();
        });
      } else {
        innerCallback();
      }
    }
  })))) : /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.adminSelectItem, " empty"),
    key: "Company-List-Item-No-Matches-Found",
    id: "Company-List-Item-ID-No-Matches-Found"
  }, /*#__PURE__*/React.createElement("span", null, "No Matches found"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("i", null, "Edit your search value")))))));
});